// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14c1666a","305":"721453dd","317":"c23e8d3c","349":"85a613c6","424":"7c53369c","440":"525b515c","453":"175433d1","520":"e58385d8","667":"2fd94555","675":"caa6a87f"}[chunkId] + ".chunk.js";
};